module.exports = __webpack_public_path__ + "img/08b-osm-solicitacao-autorizar.90aafd65.png";